
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";
import { useTheme } from "@/hooks/useTheme";

import { Converter } from "@/containers/Converter";
import { Head } from "@/components/Head";

import { MagicianSection } from "@/sections/MagicianSection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";
import { ConversionSection } from "@/sections/ConversionSection";
import { TestimonialsSection } from "@/sections/TestimonialsSection";
import { TryBeforeYouBuySection } from "@/sections/TryBeforeYouBuySection";

const WebsiteToFigma = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/WebsiteToFigma"
        ogImage="/images/website2figma-og-image.jpg"
      />

      <MagicianSection
        title={t("page/WebsiteToFigma:title")}
        subtitle={t("page/WebsiteToFigma:subtitle")}
        magicianLogoFile="figma"
        cta={{
          title: t("section/magicians:seeHowItWorks"),
          scrollToId: "ConversionSection",
        }}
      >
        <Converter disabled />
      </MagicianSection>

      <ConversionSection
        title={t("page/WebsiteToFigma:section/conversionSection.title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("section/conversion:badges.supportsGroupLayers"),
          },
          {
            iconType: "SYNC-ICON",
            text: t("section/conversion:badges.convertsWithinMinutes"),
          },
          {
            iconType: "CHECK-CIRCLED-EMPTY",
            text: t("section/conversion:badges.accuracy"),
          },
        ]}
        elements={{
          from: {
            iconType: "WEBSITE-ICON",
            image: "/images/website-preview.jpg",
            title: "Website Demo Preview",
          },
          to: {
            iconType: "FIGMA",
            image: "/images/website-figma-preview.jpg",
            title: "Figma Import Demo Preview",
          },
        }}
      />

      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/WebsiteToFigma:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/xd-to-figma-converted-file-elements.png",
          alt: t("page/WebsiteToFigma:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/WebsiteToFigma:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "SPREAD-ICON",
            title: t(
              "page/WebsiteToFigma:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/WebsiteToFigma:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "FOLDER-SIMPLE-ICON",
            title: t(
              "page/WebsiteToFigma:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/WebsiteToFigma:section/shareDesign.elements.folderStructureText",
            ),
          },
          {
            id: "ELEMENT#3",
            iconType: "CHECK-CIRCLED-EMPTY",
            title: t(
              "page/WebsiteToFigma:section/shareDesign.elements.imageSupportTitle",
            ),
            text: t(
              "page/WebsiteToFigma:section/shareDesign.elements.imageSupportText",
            ),
          },
        ]}
      />

      <TryBeforeYouBuySection
        title={t("page/WebsiteToFigma:section/tryBeforeBuy.title")}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "BOX",
            title: t(
              "page/WebsiteToFigma:section/tryBeforeBuy.elements.firstElementTitle",
            ),
            text: t(
              "page/WebsiteToFigma:section/tryBeforeBuy.elements.firstElementText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "SHIELD",
            title: t(
              "page/WebsiteToFigma:section/tryBeforeBuy.elements.secondElementTitle",
            ),
            text: t(
              "page/WebsiteToFigma:section/tryBeforeBuy.elements.secondElementText",
            ),
          },
          {
            id: "ELEMENT#3",
            iconType: "LOCK",
            title: t(
              "page/WebsiteToFigma:section/tryBeforeBuy.elements.thirdElementTitle",
            ),
            text: t(
              "page/WebsiteToFigma:section/tryBeforeBuy.elements.thirdElementText",
            ),
          },
        ]}
        cta={{
          title: t("page/WebsiteToFigma:section/tryBeforeBuy.actionLabel"),
        }}
      />
      <TestimonialsSection />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default WebsiteToFigma;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/website-to-figma',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  